import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Form } from '@carsys/form'
import { BaseStepLayout } from '../BaseStepLayout'
import { StepNavigation } from '../StepNavigation'
import { defaultStepFormProps } from '../types.d'
import { WithRunInBackgroundHelper } from '../use-should-run-in-background'
import { FormOnSubmitValues, FormValues } from './Types.d'
import { ConfigureDefaultsFields } from 'app/settings/components/RevenueGroups/ConfigureDefaultFields'
import { RevenueGroupKind } from '@cbgms/api'
import { useGetConfigureDefaultRevenueGroups } from 'app/settings/components/RevenueGroups/hooks/useGetConfigureDefaultRevenueGroups'

interface OnboardingRevenueGroupDefaultFormProps extends defaultStepFormProps<FormValues> {
  onSubmit: (values: FormOnSubmitValues) => void
}

const nonEmptyValues = (input: object): object => {
  const entriesWithActualValues = Object.entries(input).filter(([_, value]) => !!value)
  return Object.fromEntries(entriesWithActualValues)
}

export const OnboardingRevenueGroupDefaultForm: React.FC<OnboardingRevenueGroupDefaultFormProps> = ({
  onSubmit,
  prevStep,
  isFirstStep,
  isPersisting,
  onSubmitSuccess,
  hideSkip,
  shouldRunInBackground,
  initialData
}) => {
  const { t } = useTranslation()
  const [addRevenueGroup, setAddRevenueGroup] = React.useState(false)
  const { data: configPerLineType, isLoading } = useGetConfigureDefaultRevenueGroups(addRevenueGroup)

  const addRevenueFunc = () => {
    setAddRevenueGroup(!addRevenueGroup)
  }

  const formSubmit = async (v: FormValues) => {
    onSubmit({ NewValues: v, OldValues: configPerLineType || [] })
    return v
  }

  if (isLoading || !configPerLineType) return null

  const initialValues = configPerLineType.reduce((to, next) => {
    if (next.revenueGroupKind === RevenueGroupKind.CarSales) {
      return { ...to, [`vehicleSalesType_${next.vehicleSalesType}`]: next.uuid }
    } else {
      return { ...to, [`lineType_${next.lineType}`]: next.uuid }
    }
  }, {})

  return (
    <BaseStepLayout
      title={t('onboarding.revenue_groups.labour_rate_step_header')}
      subTitles={[t('onboarding.revenue_groups.labour_rate_step_info')]}
    >
      <Form
        onSubmit={formSubmit}
        onSubmitSuccess={onSubmitSuccess}
        initialValues={{ ...initialValues, ...nonEmptyValues(initialData) }}
        NavigationConfirmation={null}
      >
        {({ isSubmitting, handleSubmit }) => {
          return (
            <WithRunInBackgroundHelper enabled={shouldRunInBackground} isSubmitting={isSubmitting} onSubmit={handleSubmit}>
              <Box>
                <ConfigureDefaultsFields configPerLineType={configPerLineType} addRevenueFunc={addRevenueFunc} />
              </Box>
              <StepNavigation prevStep={prevStep} hideBack={isFirstStep} isLoading={isSubmitting || isPersisting} hideSkip={hideSkip} />
            </WithRunInBackgroundHelper>
          )
        }}
      </Form>
    </BaseStepLayout>
  )
}

export default OnboardingRevenueGroupDefaultForm
